import * as Schema from '../schema';
import assembleEntity from '../schema/assembleEntity';
import { createSelector } from 'reselect';
import { linkForNamedEntity } from '../utils/category-page';

export function selectGenre(state, id) {
  return state.entities.genres[id];
}

export const selectGenres = createSelector(
  [state => state.entities, state => state.lists.genres.entities],
  (entities, genres) => assembleEntity(Schema.GenreList, entities, genres)
);

export const selectGenresLinks = createSelector([selectGenres], genres =>
  genres.map(linkForNamedEntity('genres'))
);
